import PhotographerBookingApi from '../ScandphotosPhotographerBookingApi';
import * as types from './ScandphotosActionTypes';

function getPhotographerBookingSuccess(result: any) {
    return { type: types.SCANDPHOTOS_GET_PHOTOGRAPHERBOOKING_SUCCESS, result };
}

export function getPhotographerCalendars(
    year: number,
    month: number,
    day: number,
    address: string,
    postalCode: string,
    city: string,
    addressPointLocationLongitude: number,
    addressPointLocationLatitude: number,
    executionTime: number,
    productNames: string[],
    productIds: number[],
    brokerFirmRegionId: number,
    brokerFirmId: number,
    orderId?: number,
    numberOfMeasuredPlans?: number
) {
    return (dispatch: (result: any) => void) =>
        PhotographerBookingApi.getPhotographerCalendars(
            year,
            month,
            day,
            address,
            postalCode,
            city,
            addressPointLocationLongitude,
            addressPointLocationLatitude,
            executionTime,
            productNames,
            productIds,
            brokerFirmRegionId,
            brokerFirmId,
            orderId,
            numberOfMeasuredPlans
        ).then((result: any) => {
            dispatch(getPhotographerBookingSuccess(result));
        });
}

function getOrderInfoSuccess(result: any) {
    return { type: types.SCANDPHOTOS_GET_ORDERINFO_SUCCESS, result };
}

export function getOrderInfo(orderId: number) {
    return (dispatch: (result: any) => void) =>
        PhotographerBookingApi.getOrderInfo(orderId).then((result: any) => {
            dispatch(getOrderInfoSuccess(result));
        });
}

function updatePhotographerBookingSuccess(result: any) {
    return {
        type: types.SCANDPHOTOS_UPDATE_PHOTOGRAPHERBOOKING_SUCCESS,
        result
    };
}

export function updatePhotographer(data: any) {
    return (dispatch: (result: any) => void) =>
        PhotographerBookingApi.updatePhotographerCalendar(data).then((result: any) => {
            dispatch(updatePhotographerBookingSuccess(result));
        });
}
